import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { InvoicesState } from '../reducers/invoices.reducer';
import * as selectors from '../selectors/invoices.selectors';

@Injectable({ providedIn: 'root' })
export class InvoicesFacadeService extends FacadeService {
  constructor(public override store: Store<InvoicesState>) {
    super(store);
  }

  // OBSERVABLES
  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  invoiceNumber$ = this.storeSelect(selectors.getInvoiceNumber);
  loyaltyCard$ = this.storeSelect(selectors.getLoyaltyCard);
  dateFrom$ = this.storeSelect(selectors.getDateFrom);
  dateFromFormat$ = this.storeSelect(selectors.getDateFromFormat);
  dateFromValidation$ = this.storeSelect(selectors.getDateFromValidation);
  dateUntil$ = this.storeSelect(selectors.getDateUntil);
  dateUntilFormat$ = this.storeSelect(selectors.getDateUntilFormat);
  dateUntilValidation$ = this.storeSelect(selectors.getDateUntilValidation);
  storeValues$ = this.storeSelect(selectors.getStoreValues);
  store$ = this.storeSelect(selectors.getStore);
  viewDetailsRole$ = this.storeSelect(selectors.getViewDetailsRole);
  canDeleteInvoiceRole$ = this.storeSelect(selectors.getCanDeleteInvoiceRole);
  storeValuesWithLiterals$ = this.storeSelect(selectors.getStoreValuesWithLiterals);

  // OBSERVABLES VALUES
  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get invoiceNumber() {
    return this.storeSnapshot(this.invoiceNumber$);
  }

  get loyaltyCard() {
    return this.storeSnapshot(this.loyaltyCard$);
  }

  get dateFromFormat() {
    return this.storeSnapshot(this.dateFromFormat$);
  }

  get dateUntilFormat() {
    return this.storeSnapshot(this.dateUntilFormat$);
  }

  get storeValues() {
    return this.storeSnapshot(this.storeValues$);
  }

  get Store() {
    return this.storeSnapshot(this.store$);
  }

  get storeValuesWithLiterals() {
    return this.storeSnapshot(this.storeValuesWithLiterals$);
  }
}
